import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: 1,
  question: "¿Qué cursos ofrece Zafiro Investments?",
  answer: "Ofrecemos cursos especializados en análisis de acciones, formación en bolsa de valores estadounidense, estrategias de inversión, y capacitación en herramientas analíticas y software financiero."
}, {
  id: 2,
  question: "¿Necesito experiencia previa para inscribirme?",
  answer: "No es necesario tener experiencia previa. Nuestros cursos están diseñados para hispanohablantes de todos los niveles, desde principiantes hasta inversores con experiencia que buscan mejorar sus habilidades."
}, {
  id: 3,
  question: "¿Qué es el mercado de valores estadounidense?",
  answer: "El mercado de valores de EE. UU. es uno de los más grandes y líquidos del mundo, donde se negocian acciones de empresas públicas. Incluye bolsas como NYSE y NASDAQ, y ofrece oportunidades de inversión en empresas líderes globales."
}, {
  id: 4,
  question: "¿Cómo puedo empezar a invertir en la bolsa?",
  answer: "El primer paso es educarte sobre los fundamentos del mercado. Nuestros cursos te enseñan análisis técnico y fundamental, gestión de riesgos, y cómo usar plataformas de trading para realizar inversiones informadas."
}, {
  id: 5,
  question: "¿Qué estrategias de inversión enseñan?",
  answer: "Cubrimos diversas estrategias incluyendo inversión a largo plazo, trading de corto plazo, análisis de tendencias, gestión de cartera, y técnicas de evaluación de empresas basadas en casos reales del mercado estadounidense."
}, {
  id: 6,
  question: "¿Recibiré certificación al completar un curso?",
  answer: "Sí, al finalizar nuestros cursos recibirás una certificación reconocida en el ámbito financiero que valida tus conocimientos y habilidades en inversión en el mercado estadounidense."
}, {
  id: 7,
  question: "¿Ofrecen soporte después del curso?",
  answer: "Absolutamente. Brindamos soporte y seguimiento personalizado incluso después de completar el curso, para ayudarte a aplicar lo aprendido y responder cualquier pregunta que surja en tu camino como inversor."
}, {
  id: 8,
  question: "¿Cuál es la diferencia entre análisis técnico y fundamental?",
  answer: "El análisis técnico estudia patrones de precios y volumen en gráficos para predecir movimientos futuros. El análisis fundamental evalúa la salud financiera de una empresa (ingresos, ganancias, deuda) para determinar su valor intrínseco. Enseñamos ambos enfoques."
}];
export default function FrequentlyAskedQuestions() {
  return <section className="bg-background py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center mb-12 animate-fade-in-up">
          <h2 className="text-3xl font-semibold text-foreground tracking-wide mb-4">
            Preguntas Frecuentes
          </h2>
          <p className="text-base text-muted-foreground leading-relaxed">
            Encuentra respuestas a las preguntas más comunes sobre nuestros
            cursos, el mercado de valores y estrategias de inversión.
          </p>
        </div>

        <div className="mx-auto max-w-3xl">
          <Accordion type="single" collapsible className="space-y-2 animate-fade-in-up">
            {faqs.map((faq, i) => <AccordionItem key={faq.id} value={`item-${faq.id}`} data-index={i} className="bg-black border border-white/10 rounded-md px-6 shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                <AccordionTrigger className="text-base font-semibold text-white hover:text-accent transition-colors duration-[var(--duration-fast)]">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-white/90 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}